export class HttpError extends Error {
	constructor(
		public message: string,
		public displayMessage?: string,
	) {
		super(message);
	}
}
